.host {
  height: 100%;
  background: rgba(var(--color-benefits), 0.4);
}

.content {
  position: relative;
}

.entry {
  position: absolute;
  top: -7.6rem;
  left: 50%;
  width: 35rem;
  height: 10.8rem;
  transform: translateX(-50%);
  animation: slideDown 0.5s ease-in-out;
}

.entryReverse {
  opacity: 0;
  animation: slideUp 1s ease-in-out;
}

.entry::before {
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    #ddb8a6 0%,
    rgba(221, 184, 166, 0) 145.19%
  );
  border-radius: 1.6rem;
  opacity: 0.3;
  content: '';
}

.entry::after {
  position: absolute;
  right: 1.6rem;
  bottom: 1.5rem;
  left: 1.6rem;
  height: 3rem;
  background: linear-gradient(
    180deg,
    rgba(221, 184, 166, 0) -62.5%,
    #ddb8a6 100%
  );
  border-radius: 0.8rem;
  opacity: 0.9;
  content: '';
}

.cardWrapper {
  width: 28.44rem;
  height: 45rem;
  overflow: hidden;
}

.cardElem {
  position: relative;
  width: 100%;
  height: 100%;
  transform: rotateY(180deg);
  transform-style: preserve-3d;
}

.cardElem.cardPin {
  animation: slideCard 2s cubic-bezier(0.83, 0, 0.59, 0.61) forwards 0.3s;
}

.cardElem.cardPinReverse {
  animation: unSlideCard 1.6s cubic-bezier(0.83, 0, 0.59, 0.61) forwards;
}

.cardElem.cardPanReverse {
  animation: counterRotateCard 2s cubic-bezier(0.83, 0, 0.59, 0.61) forwards;
}

.cardFace {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

.cardFace.cardBack {
  display: block;
  box-sizing: border-box;
  transform: rotateY(180deg);
}

.cardSvg {
  width: 28.44rem;
  height: 45rem;
}

.successBadge {
  position: absolute;
  top: -3rem;
  right: -3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 8rem;
  height: 8rem;
  background-color: var(--color-state--success);
  border-radius: 3.2rem;
  opacity: 0;
  filter: drop-shadow(0px 10px 20px rgba(113, 201, 196, 0.6));
}

.successBadge.pin {
  opacity: 1;
  transition: opacity 0.5s ease;
  transition-delay: 0.8s;
}

.successBadge.pan {
  opacity: 1;
  transition: opacity 0.5s ease;
  transition-delay: 1.9s;
}

.successBadge svg {
  width: 2.4rem;
  height: 2.4rem;
  color: var(--color-white);
}

@keyframes slideCard {
  0% {
    transform: rotateY(180deg);
  }

  50% {
    transform: rotateY(0);
  }

  100% {
    transform: rotate(0) translateY(-36%);
  }
}

@keyframes unSlideCard {
  0% {
    transform: rotate(0) translateY(-36%);
  }

  50% {
    transform: rotateY(0);
  }

  100% {
    transform: rotateY(0);
  }
}

@keyframes counterRotateCard {
  0% {
    transform: rotateY(180deg);
  }

  100% {
    transform: rotate(0);
  }
}

@keyframes slideDown {
  from {
    transform: translate(-50%, -2rem);
    opacity: 0;
  }

  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translate(-50%, 0);
    opacity: 1;
  }

  to {
    transform: translate(-50%, -2rem);
    opacity: 0;
  }
}
